var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7768 8.89717C10.4405 8.66894 9.99869 8.67009 9.6636 8.90008L9.18113 9.23123C8.64373 9.60006 7.92905 9.58002 7.4125 9.18249C6.92568 8.80779 6.46102 8.40603 6.01977 7.9803C5.59399 7.53904 5.19228 7.07443 4.81757 6.58756C4.42 6.07106 4.40001 5.35638 4.76884 4.81893L5.09999 4.33646C5.32993 4.00138 5.33112 3.55955 5.1029 3.22323L3.72183 1.18795C3.34031 0.625751 2.59772 0.437393 1.99532 0.751665C0.77851 1.38653 0.267628 2.85472 0.825147 4.10886C1.62764 5.91423 2.70515 7.56556 4.00556 9.01171L4.98836 9.99451C6.43454 11.2949 8.08588 12.3724 9.89121 13.1749C11.1454 13.7324 12.6134 13.2219 13.2482 12.0051C13.5625 11.4028 13.3743 10.6598 12.8121 10.2782L10.7768 8.89717Z",
    fill: "#021317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.83c6a9a90ce3403098862799e8fadcb4.svg";
export { ForwardRef as ReactComponent };